import React, { useEffect, useState } from 'react'
import { useQueryClient } from 'react-query'
import { useHistory } from 'react-router-dom'
import CustomAddPage from '../../components/CustomComponents/CustomAddPage'
import { createDocument, updateDocumentByID } from '../../lib/RestApi/customApiHandler'
import { isArray, uploadFilesToAws } from '../../shared/constants'

export default function AddAllowanceType({ allowanceType: allowanceTypeData }) {
  const queryClient = useQueryClient()
  const history = useHistory()
  const [allowanceType, setAllowanceType] = useState({
    name: allowanceTypeData ? allowanceTypeData.name : '',
    image: '',
    description: allowanceTypeData ? allowanceTypeData.description : '',
  })

  const data = [
    { label: 'Allowance Type Name', value: allowanceType.name, name: 'name' },
    { label: 'Allowance Type Image', type: 'IMAGE', name: 'image' },
    // { label: 'Allowance Image', value: allowanceType.image, name: 'image', type: 'file' },
    { label: 'Allowance Type Description', value: allowanceType.description, name: 'description' },
  ]

  const [loading, setLoading] = useState(false)

  const handleAllowanceType = async () => {
    setLoading(true)
    let location = allowanceType.image
    if (allowanceType.image !== typeof String) {
      if (!isArray(allowanceType.image)) {
        location = await uploadFilesToAws(allowanceType.image)
      }
    }

    if (allowanceTypeData) {
      updateDocumentByID('/update/allowanceType', allowanceTypeData._id, { image: location?.length && location[0], name: allowanceType.name, description: allowanceType.description })
      queryClient.invalidateQueries('allowance-type')
      setLoading(false)
    } else {
      createDocument('/create/allowance/type', { image: location?.length && location[0], name: allowanceType.name, description: allowanceType.description })
      console.log({ image: location?.length && location[0], name: allowanceType.name, description: allowanceType.description })
      queryClient.invalidateQueries('allowance-type')
      setLoading(false)
    }

    history.push('/allowance-Type')
  }

  return (
    <CustomAddPage
      heading="Allowance Type"
      redirect={'ALLOWANCE_TYPE'}
      currentData={allowanceType}
      loading={loading}
      state={allowanceType}
      setState={setAllowanceType}
      handleClick={handleAllowanceType}
      inputFields={data}
    />
  )
}
